(function () {
	if (window.location.href.indexOf("kpm-plus") > -1) {
		document.body.classList.add("kpm-plus");
	}
})();
